import { render, staticRenderFns } from "./HelicopterManagement.vue?vue&type=template&id=d95287ee&scoped=true&"
import script from "./HelicopterManagement.vue?vue&type=script&lang=js&"
export * from "./HelicopterManagement.vue?vue&type=script&lang=js&"
import style0 from "./HelicopterManagement.vue?vue&type=style&index=0&id=d95287ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95287ee",
  null
  
)

export default component.exports